import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

const markerSize = size[28]

export const slider = css`
  min-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
`

export const carouselDescription = css`
  font-size: ${fontSize.smMd};
`

export const carouselList = css`
  display: flex;
  flex-direction: column;
  gap: ${size[16]};
  padding: 0;
  margin: ${size[20]} 0 ${size[32]};
  max-width: 40rem;

  li {
    display: flex;
    align-items: center;
    gap: ${size[12]};
    flex-shrink: 0;
    font-size: ${fontSize.smMd};

    &::before {
      content: '';
      display: block;
      min-width: ${markerSize};
      min-height: ${markerSize};
      background-image: url("data:image/svg+xml,%3Csvg width='36' height='36' viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.59397 21.8482C0.468677 19.7229 0.468679 16.2771 2.59397 14.1518L14.1518 2.59397C16.2771 0.468677 19.7229 0.468679 21.8482 2.59397L33.406 14.1518C35.5313 16.2771 35.5313 19.7229 33.406 21.8482L21.8482 33.406C19.7229 35.5313 16.2771 35.5313 14.1518 33.406L2.59397 21.8482Z' stroke='%23020288' stroke-width='1.36054' stroke-linejoin='round'/%3E%3Crect x='17.9824' y='7.04639' width='15.4547' height='15.4547' transform='rotate(45 17.9824 7.04639)' fill='%23A4FBC4'/%3E%3Cpath d='M14.1289 18.5769L18.1085 22.5565L27.2241 13.4409' stroke='%23020288' stroke-width='1.36054' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
      background-size: ${markerSize} ${markerSize};
      background-repeat: no-repeat;
      margin-top: -4px;
      margin-left: -1px;
    }
  }
`

export const active = css`
  position: relative;
`

export const inner = css`
  margin: 0 auto;
  min-width: unset;
  width: ${width.container.large};
`

export const content = css`
  height: 100%;
  display: flex;
  justify-content: center;
`

export const hero = css`
  position: relative;
  overflow: visible;
  z-index: 1;
  border-radius: 0 ${size[80]} 0 0;
  padding: 0;
  margin: ${size[60]} 0;
  height: 100%;

  ${breakpoint.up('md')} {
    max-height: 60rem;
  }

  ${breakpoint.up('smMd')} {
    height: calc(100vh - 92px);
    margin: 0 0;
    border-radius: 20px 200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${size[32]};
  }

  ${breakpoint.up('sm')} {
    background: 0 0;
  }

  ${breakpoint.down(48)} {
    margin-bottom: ${size[120]};
  }
`

export const heroCell = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const heroImageWrapper = css`
  width: 100%;
  max-width: 500px;

  ${breakpoint.up('smMd')} {
    max-width: 800px;
  }

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`

export const cellContent = css`
  max-width: ${width.container.standard};
  width: 100%;
  padding: 0 ${size[20]};

  ${breakpoint.up('smMd')} {
    padding: ${size[20]};

    h3 {
      max-width: ${width.modal.compact};
    }
  }

  ${breakpoint.up(88)} {
    padding: 0;
    padding-right: ${size[8]};
  }
`

export const counter = (theme: Theme) => css`
  margin-bottom: ${size[32]};
  display: flex;
  justify-content: space-between;
  align-items: center;

  h4 {
    color: ${theme.palette.tertiary.upperMediumContrast};
    font-size: ${fontSize.sm};
    font-weight: 400;
    margin: 0;
  }

  ${breakpoint.up('smMd')} {
    h4 {
      font-size: ${pxToRem(24)};
    }
  }
`

export const cta = css`
  display: flex;
  flex-direction: column;
  row-gap: ${size[12]};

  margin-top: ${size[60]};

  a {
    width: 100%;
  }

  ${breakpoint.up('smMd')} {
    flex-direction: row;
    column-gap: ${size[24]};
  }
`

export const controls = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: ${size[12]};

  button {
    background-color: transparent;
    border: none;
    font-size: ${fontSize.lg};
    color: ${theme.palette.primary.mainContrast};
    cursor: pointer;
  }

  svg {
    width: ${size[20]};

    ${breakpoint.up('smMd')} {
      width: ${size[32]};
    }
  }
`
